module.exports = __webpack_public_path__ + "static/media/three-dots.b15c0367.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/form/Type/three-dots.svg
 ** module id = 196
 ** module chunks = 0
 **/